import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SnackbarService } from '@services/snackbar/snackbar.service';
import moment from 'moment';

import { PageAction } from '../../components/page-actions/page-actions.component';
import { Models } from '@ibexfusion/models';
import { DataTableComponent, DataTableEvent } from '../../components/data-table/data-table.component';
import { DialogService } from '@services/dialog/dialog.service';
import { RedirectService } from '@services/redirects/redirect.service';
import { ScreenService } from '@services/screens/screen.service';
import { CustomerService } from '@services/customers/customer.service';

@Component({
    selector: 'app-redirects',
    templateUrl: 'redirects.component.html',
    styleUrls: ['redirects.component.scss'],
    providers: [RedirectService, ScreenService, CustomerService],
    standalone: false
})
export class RedirectsComponent implements OnInit {

  @Input() screenUUID: string;

  public pageActions: PageAction[];

  public title = 'Redirects';

  public screens: Screen[];

  public customers: Models.Customer[];

  public isLoading = false;

  public columns = [
    { prop: 'title', name: 'Title' },
    { prop: 'visitCount', name: 'Visit Count' },
    {
      prop: 'lastVisit', name: 'Last Visit', valueTransformer: function(date) {
        return moment(date).format('DD-MM-YYYY  HH:mm');
      }
    },
  ];

  public searchColumns = [{ prop: 'title' }]

  public params: any;

  @ViewChild(DataTableComponent) dataTable: DataTableComponent;

  constructor(
    private dialogService: DialogService,
    public redirectService: RedirectService,
    private screenService: ScreenService,
    private customerService: CustomerService,
    private route: ActivatedRoute,
    private router: Router,
    private snackbar: SnackbarService,
  ) {
  }

  ngOnInit() {
    this.isLoading = true;
    if (this.screenUUID) {
      this.params = {
        screenUUID: this.screenUUID
      };
    }
    this.getData();
    this.createPageActions();

  }

  public onCustom(event: DataTableEvent) {
    this.router.navigate(['redirects/log', event.row.uuid]);
  }

  public onDetail(event: DataTableEvent) {
    this.router.navigate(['redirects', event.row._id]);
  }

  public onEdit(event: DataTableEvent) {
    this.router.navigate(['redirects', event.row._id, 'edit']);
  }

  public onRemove(event: DataTableEvent): void {
    this.dialogService
      .confirm('Remove Redirect?')
      .then(res => {
        if (!res) {
          return;
        }
        return this.redirectService.remove(event.row._id).then(() => {
          this.dataTable.refresh();
          this.snackbar.success('Redirect removed');
        }, error => {
          this.snackbar.error('Failed');
          console.error(error);
        });
      });
  }

  private createPageActions(): void {
    this.pageActions = [
      new PageAction({
        icon: 'transform',
        title: 'Create New Redirect',
        callback: () => {
          this.router.navigate(['redirects/create']);
        }
      })
    ];
  }

  private getData() {
    this.isLoading = false;
  }

}
